import { ActionCreator } from 'store/redux/ActionCreators';
import { ModalMeta, ModalSize } from '../types';

export enum ModalActionType {
  Open = 'OPEN_MODAL',
  Close = 'CLOSE_MODAL',
  Resize = 'RESIZE_MODAL',
}

export interface OpenModal {
  type: ModalActionType.Open;
  payload?: number;
  meta: ModalMeta;
}

export interface CloseModal {
  type: ModalActionType.Close;
  payload?: number;
}

export interface ResizeModal {
  type: ModalActionType.Resize;
  payload: ModalSize;
}

export function openModal(index: number | undefined, _error: never, meta: ModalMeta): OpenModal {
  return {
    type: ModalActionType.Open,
    payload: index,
    meta,
  };
}

export function closeModal(index?: number): CloseModal {
  return {
    type: ModalActionType.Close,
    payload: index,
  };
}

export function resizeModal(size: ModalSize): ResizeModal {
  return {
    type: ModalActionType.Resize,
    payload: size,
  };
}

export type ModalActions = OpenModal | CloseModal | ResizeModal;

export interface ModaActionsCreators {
  openModal: ActionCreator<
    { index: number; error: never; meta: ModalMeta},
    OpenModal
  >;
  closeModal: ActionCreator<
    { index: number },
    CloseModal
  >;
  resizeModal: ActionCreator<
    { size: number },
    ResizeModal
  >;
}
